import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import ReviewModerationPanel from '../components/ReviewModerationPanel';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PublishedReviewsAdmin() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = localStorage.getItem('token');
    if (!t) navigate('/dashboard');
  }, [navigate]);

  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const authConfig = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

  return (
    <div className="pt-20 min-h-screen bg-[#F7F8FA] pb-20" data-testid="published-reviews-admin">
      <div className="max-w-4xl mx-auto px-6">
        <button onClick={() => navigate('/admin')} className="text-[#F57C20] text-sm mb-4 flex items-center gap-2" data-testid="back-to-admin">
          <FiArrowLeft className="w-4 h-4" /> Back to Admin
        </button>
        <h1 className="text-3xl font-light text-[#1A1A2E] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Published <span className="text-[#F57C20] italic">Reviews</span>
        </h1>
        <ReviewModerationPanel
          apiBase={`${API}/api/admin/reviews`}
          authConfig={authConfig}
          variant="admin"
        />
      </div>
    </div>
  );
}
